import { useState } from 'react'

import { Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import CreateMemberEnrollmentSheet from './CreateMemberEnrollmentSheet'

type CreateEnrollmentButtonProps = {
  memberId: string
  planYear: number
  isTieredAllowancesEmployer: boolean
}

const CreateEnrollmentButton = ({
  memberId,
  planYear,
  isTieredAllowancesEmployer,
}: CreateEnrollmentButtonProps) => {
  const { reload } = useWindowLocation()

  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const handleCreateEnrollment = () => {
    setIsSheetOpen(true)
  }

  const handleCloseSheet = () => {
    setIsSheetOpen(false)
  }

  const handleEnrollmentCreated = () => {
    // Refresh the page to show the new enrollment.
    // TODO: Use query client to invalidate enrollments query once this query is performed
    // using the query client.
    reload()
  }

  return (
    <div>
      <Button onClick={handleCreateEnrollment} variant='primary'>
        Create Enrollment
      </Button>
      <CreateMemberEnrollmentSheet
        memberId={memberId}
        planYear={planYear}
        isTieredAllowancesEmployer={isTieredAllowancesEmployer}
        isOpen={isSheetOpen}
        onClose={handleCloseSheet}
        onEnrollmentCreated={handleEnrollmentCreated}
      />
    </div>
  )
}

export default CreateEnrollmentButton
